exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".name[data-v-4f722fe6]{font-size:15px;font-weight:700}.description[data-v-4f722fe6]{font-size:14px;color:#7d7d7d;font-weight:700}.cat-item[data-v-4f722fe6]{font-size:17px;min-height:40px;cursor:pointer}.food-img[data-v-4f722fe6]{border-radius:5px;-o-object-fit:cover;object-fit:cover}.nowrap-text[data-v-4f722fe6]{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4f722fe6","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SimpleCatItem.vue
// module id = cKRK
// module chunks = 0